import { ReactNode } from 'react'
import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material'
import * as css from './styles'

interface IProps {
  className?: string
  isSelected: boolean
  onSelected: (e) => void
  text: string
  icon: ReactNode
}

export const DatasetMenuItem = ({ className, isSelected, onSelected, text, icon }: IProps) => {
  return (
    <css.MenuItem className={className}>
      {isSelected ? <css.GreenSelectedBar /> : null}
      <MenuItem onClick={onSelected} selected={isSelected}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={
            <Typography css={isSelected ? css.selectedTypography : css.typography}>
              {text}
            </Typography>
          }
        />
      </MenuItem>
    </css.MenuItem>
  )
}
